// extracted by mini-css-extract-plugin
export default {"slideGrid":"sbjnWcJKZzgDvduFc7t2","carouselWrapper":"KzXrjcQxPnEYyLN1fRsV"};